import {
  createAccessibilityRequest
} from "./chunk-TEKJC3FB.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/accessibility/createRequest.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useCreateAccessibilityRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createAccessibilityRequest,
    onSuccess: (data) => {
      queryClient.setQueryData(["accessibilityRequests"], (old) => {
        if (old) {
          return __spreadValues(__spreadValues({}, old), data);
        }
        return data;
      });
    }
  });
};

export {
  useCreateAccessibilityRequest
};
//# sourceMappingURL=chunk-YNIYZCFS.mjs.map